/* eslint-disable require-jsdoc */
export default class {
  /**
   * Xử lý chung cho store chart
   * @param {*} _name name
   * @param {*} _api api
   * HTHIEP 21.06.2023
   */
  constructor(_name, _api) {
    this.state = {
      /**
       * loading
       */
      loading: false,

      /**
       * Data chart
       */
      items: [],
    };

    this.actions = {
      /**
       * Load dữ liệu chart
       * @param {*} context context
       * @param {*} payload payload
       * HTHIEP 21.06.2023
       */
      async load(context, payload) {
        let res = null;
        if (!_api) {
          throw new Error('Chưa khai báo api');
        }
        if (typeof _api.getChartData !== 'function') {
          throw new Error('Chưa định nghĩa hàm getChartData');
        }
        try {
          context.commit('updateLoading', true);
          res = await _api.getChartData(payload || {});
          if (res) {
            context.commit('setItems', res);
          } else {
            console.warn('Chart Data empty');
          }
        } finally {
          context.commit('updateLoading', false);
        }
        return res;
      },

      /**
       * giải phóng dữ liệu store
       * @param {*} context context
       * HTHIEP 21.06.2023
       */
      dispose(context) {
        // clear items
        context.commit('setItems', []);
        context.commit('updateLoading', false);
      },
      setItems(context, payload) {
        context.commit('setItems', payload);
      }
    };

    this.mutations = {
      /**
       * Update trạng thái loadding dữ liệu
       * @param {*} state
       * @param {*} data
       * HTHIEP 21.06.2023
       */
      updateLoading(state, data) {
        state.loading = data;
      },

      /**
       * Set items
       * @param {*} state state
       * @param {*} data data
       * HTHIEP 21.06.2023
       */
      setItems(state, data) {
        state.items = data;
      },
    };
  }
}
